export default [
  {
    path: "*",
    meta: {
      name: "",
      requiresAuth: false
    },
    redirect: {
      path: "/dashboard"
    }
  },
  {
    path: "/app/death_eaters_rising",
    meta: {
      name: "Death eaters rising",
      requiresAuth: false,
      category: "Harry Potter",
      description: "Calculate statistics of game choices",
      browsable: true
    },
    name: "DeathEatersRising",
    component: () => import(`@/views/apps/death_eaters_rising/DeathEatersRisingView.vue`)
  },
  {
    path: "/app/termbank/termmaster",
    meta: {
      name: "TermMaster",
      requiresAuth: false,
      category: "Word games",
      description: "Bilingual hangman of scientific terms",
      browsable: true
    },
    name: "TermbankHangman",
    component: () => import(`@/views/apps/termbank/TermMaster.vue`)
  },
  {
    path: "/app/mwebank/mwemaster",
    meta: {
      name: "MweMaster",
      requiresAuth: false,
      category: "Word games",
      description: "Hangman of greek multiword expressions",
      browsable: true
    },
    name: "MwebankHangman",
    component: () => import(`@/views/apps/mwebank/MweMaster.vue`)
  },
  {
    path: "/app/mwebank/mwehunter",
    meta: {
      name: "MweHunter",
      requiresAuth: false,
      category: "Word games",
      description: "Try to find as many MWE as you can",
      browsable: true
    },
    name: "Mwebankhunter",
    component: () => import(`@/views/apps/mwebank/MweHunter.vue`)
  },
  // --------------------------------------------------------
  //                  Exclusive mode apps
  // --------------------------------------------------------
  {
    path: "/termmaster",
    meta: {
      name: "TermMaster",
      requiresAuth: false,
      browsable: false,
      exclusive: true
    },
    component: () => import(`@/views/apps/termbank/TermMaster.vue`)
  },
  {
    path: "/mwemaster",
    meta: {
      name: "MweMaster",
      requiresAuth: false,
      browsable: false,
      exclusive: true
    },
    component: () => import(`@/views/apps/mwebank/MweMaster.vue`)
  },
  {
    path: "/mwehunter",
    meta: {
      name: "MweHunter",
      requiresAuth: false,
      browsable: false,
      exclusive: true
    },
    component: () => import(`@/views/apps/mwebank/MweHunter.vue`)
  },

  // {
  //   path: "/app/tfidf",
  //   meta: {
  //     name: "TF-IDF calculator (Syspro 2018)",
  //     requiresAuth: false,
  //     shortName: "TD-IDF",
  //     category: "Data science",
  //     browsable: true
  //   },
  //   name: "TfIdf",
  //   component: () => import(`@/views/apps/data_science/TF_IDF.vue`)
  // },
  // {
  //   path: "/app/dbtrainer",
  //   meta: {
  //     name: "Database Trainer",
  //     requiresAuth: false,
  //     category: "Databases",
  //     browsable: true
  //   },
  //   name: "DatabaseTrainer",
  //   component: () => import(`@/views/apps/db/DatabaseTrainer.vue`)
  // },
  // {
  //   path: "/app/networking/basics",
  //   meta: {
  //     name: "Networking basics",
  //     requiresAuth: false,
  //     category: "Networking",
  //     browsable: true
  //   },
  //   name: "NetworkingBasics",
  //   component: () => import(`@/views/apps/networking/NetworkingBasics.vue`)
  // },

  // -----------------------------------------------
  // {
  //   path: "/app/os/disk_scheduling",
  //   meta: {
  //     name: "Disk scheduling algorithms",
  //     requiresAuth: false,
  //     shortName: "Disk scheduling",
  //     category: "Operating systems",
  //     browsable: true
  //   },
  //   component: () => import(`@/views/apps/os/DiskScheduling.vue`)
  // },
  // {
  //   path: "/app/os/page_replacement",
  //   meta: {
  //     name: "Page replacement algorithms",
  //     requiresAuth: false,
  //     shortName: "Page replacement",
  //     category: "Operating systems",
  //     browsable: true
  //   },
  //   component: () => import(`@/views/apps/os/PageReplacement.vue`)
  // },
  // {
  //   path: "/app/os/process_scheduling",
  //   meta: {
  //     name: "Process scheduling algorithms",
  //     requiresAuth: false,
  //     shortName: "Process scheduling",
  //     category: "Operating systems",
  //     browsable: true
  //   },
  //   component: () => import(`@/views/apps/os/ProcessScheduling.vue`)
  // },
  // {
  //   path: "/app/parallel_systems/mpi",
  //   meta: {
  //     name: "MPI type visualization",
  //     requiresAuth: false,
  //     shortName: "MPI data types",
  //     category: "Parallel systems",
  //     browsable: true
  //   },
  //   component: () => import(`@/views/apps/parallel_systems/MPITools.vue`)
  // },
  // {
  //   path: "/app/other/lean",
  //   meta: {
  //     name: "LEAN",
  //     requiresAuth: false,
  //     category: "Other",
  //     browsable: true
  //   },
  //   component: () => import(`@/views/apps/other/Lean.vue`)
  // },
  {
    path: "/dashboard",
    meta: {
      name: "Dashboard View",
      requiresAuth: false
    },
    component: () => import(`@/views/Dashboard.vue`)
  }
  // --------------------------------------------------------
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   view: "UserProfile"
  // },
  // {
  //   path: "/table-list",
  //   name: "Table List",
  //   view: "TableList"
  // },
  // {
  //   path: "/typography",
  //   view: "Typography"
  // },
  // {
  //   path: "/icons",
  //   view: "Icons"
  // },
  // {
  //   path: "/maps",
  //   view: "Maps"
  // },
  // {
  //   path: "/notifications",
  //   view: "Notifications"
  // },
  // {
  //   path: "/upgrade",
  //   name: "Upgrade to PRO",
  //   view: "Upgrade"
  // }
];
